var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreviousicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 5",
    cx: 6.49978,
    cy: 6.49978,
    r: 6.49978,
    transform: "matrix(-1 0 0 1 14 0.5)",
    stroke: "#192126",
    strokeWidth: 0.966758,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2",
    d: "M8.92187 3.95335C7.65271 5.22251 6.94115 5.93407 5.67199 7.20324L8.92188 10.4531",
    stroke: "#192126",
    strokeWidth: 0.966758,
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviousicon);
export default __webpack_public_path__ + "static/media/previousicon.b766aaad71e22146657f0dfb04257d18.svg";
export { ForwardRef as ReactComponent };